<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <ActionBar :show="true" :back="false" v-model:search="query.search" v-model:start_date="query.start_date" v-model:end_date="query.end_date"/>
      </div>
    </template>

    <template #layoutContent>
      <Loader :is-loading="isLoading">
        <div class="" v-for="(company, index) in companiesStats" :id="index"  :key="company?.id">
          <Card container-class="card shadow-sm mb-5 p-5 px-10 w-100">
            <div class="row mt-5">
              <div class="col-12 col-md-5 col-lg-2 mb-4 d-flex justify-align-center align-items-center">
                <h1>{{company?.name}}</h1>
              </div>
              <StatCard :title="$t('expenses.expenses')" :amount="company.officeExpensesTotalAmount" :total="company.officeExpensesTotalCount" color="primary" :size-lg="3"/>
              <StatCard :title="$t('expenses.status.notValidated')" :amount="company.officeExpensesUnvalidatedAmount" :total="company.officeExpensesUnvalidatedCount" color="danger" :size-lg="3"/>
              <StatCard :title="$t('expenses.status.validated')" :amount="company.officeExpensesValidatedAmount" :total="company.officeExpensesValidatedCount" color="success" :size-lg="3"/>
            </div>
          </Card>
          <div class="row">
            <div class="col-12 col-md-4 mb-5" v-for="(office, index) in company.offices" :key="office?.id">
              <OfficeStatCard
                  :title="office?.name"
                  :company="company?.id"
                  :id="office?.id"
                  :not-validated="office?.officeExpensesUnvalidatedCount"
                  :not-approved="office?.officeExpensesUnapprovedCount"
                  :validated="office?.officeExpensesValidatedCount"
                  :total="office?.officeExpensesTotalCount"
              />
            </div>
          </div>
        </div>
      </Loader>

      <ExpenseFileModal id="expense_file_modal"/>

    </template>

  </SubLayout>
</template>

<script setup> 
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Card from "@/components/Card.vue";
import StatCard from "../../components/StatCard";
import {onMounted, ref, computed, watch, nextTick} from "vue";
import OfficeStatCard from "./components/OfficeStatCard.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useLocales } from "@/composables/locales";
import ActionBar from "./components/ActionBar.vue";
import ExpenseFileModal from "./components/ExpenseFileModal.vue";
import Loader from "@/components/Loader.vue";

const store = useStore()
const {locale} = useLocales()
const router = useRouter()

const title = ref("breadcrumbs.expenses.title")

const query = ref({
  start_date: '',
  end_date: '',
  search: "",
})

const isLoading = ref(false)
const companiesStats = ref([])
const officesStats = ref([
        {
            "id": "kMKBlaP9",
            "name": "D\u00f6hler Nigeria",
            "currency": {
                "hash_id": "yVOm61j3",
                "name": "Nigerian",
                "iso": "NGN",
                "symbol": "\u20a6",
                "exchange": "1",
                "created_at": "2022-02-18T10:29:27.000000Z",
                "updated_at": "2024-12-16T10:05:59.000000Z",
                "isDefault": false,
                "deleted_at": null,
                "watermelon_id": 106
            },
            "officeExpensesUnvalidatedAmount": 0,
            "avances_count": 0,
            "avances_sum_amount": 0,
            "officeExpensesValidatedAmount": 0,
            "officeExpensesUnapprovedAmount": 0,
            "officeExpensesTotalAmount": 0,
            "officeExpensesUnvalidatedCount": 0,
            "officeExpensesValidatedCount": 0,
            "officeExpensesTotalCount": 0
        },
        {
            "id": "MXKo645V",
            "name": "D\u00f6hler Ghana",
            "currency": {
                "hash_id": "a7WER9O5",
                "name": "Ghanaian",
                "iso": "GHS",
                "symbol": "GH\u20b5",
                "exchange": "1",
                "created_at": "2022-02-18T10:29:27.000000Z",
                "updated_at": "2024-12-16T10:05:59.000000Z",
                "isDefault": false,
                "deleted_at": null,
                "watermelon_id": 53
            },
            "officeExpensesUnvalidatedAmount": 0,
            "avances_count": 0,
            "avances_sum_amount": 0,
            "officeExpensesValidatedAmount": 0,
            "officeExpensesTotalAmount": 0,
            "officeExpensesUnvalidatedCount": 0,
            "officeExpensesUnapprovedAmount": 0,
            "officeExpensesValidatedCount": 0,
            "officeExpensesTotalCount": 0
        }
])


const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

const currentCompany = computed(() => store.getters['offices/getSelectedCompany'])


const breadcrumbs = ref([
  {
    name: currentCompany.value?.name || '',
    path: '/accounting'
  }
])

watch(() => currentCompany.value, value => {
  if(value){
    loadOfficesWithExpensesStats()
    loadCompanyOffices()
  }
} )

watch(() => query.value.start_date, (value) => {
  if (!isLoading.value) {
    loadOfficesWithExpensesStats()
  }
}, {deep: true})


function loadOfficesWithExpensesStats () {
  if(query.value.end_date && query.value.start_date && currentCompany.value){
    try {
      isLoading.value = true
      store.dispatch('expenses/loadAccountingDashboardData', query.value).then(resp => {
        companiesStats.value = resp.data.data
        isLoading.value = false
      })
    }catch (e) {

    }finally {
      isLoading.value = false
    }

  }
  
}

function loadCompanyOffices () {
  if(currentCompany.value){
    store.dispatch('offices/loadSocietyOffices', currentCompany.value.id)
  }
}

onMounted(() => {
  loadOfficesWithExpensesStats()
  loadCompanyOffices()
})


</script>
<style scoped>
.accordion-button:not(.collapsed) {
    background-color: transparent !important;
}
.accordion-item {
    background-color: transparent !important;
    border: 0px solid transparent !important
}
.accordion-button{
  background-color: transparent !important;
}
.accordion-button::after {
  display: none !important;
}
.separator-with-icon {
  display: flex;
  align-items: center;
  gap: 10px;
}

.separator {
  width: 1px;
  height: 30px;
  background-color: #ccc;
}

.bi {
  font-size: 1.2rem; /* Ajustez la taille de l'icône */
  color: #333;
}


</style>